export default {
  登录已过期: '登录已过期',
  查询地址户信息: '查询地址户信息',
  获取地址户信息失败: '获取地址户信息失败',
  保存收货地址失败: '保存收货地址失败',
  收货地址: '收货地址',
  名字: '名字',
  请输入名字: '请输入名字',
  手机号: '手机号',
  请输入手机号: '请输入手机号',
  请输入邮箱: '请输入邮箱',
  地址: '地址',
  请选择地区: '请选择地区',
  请输入详细地址: '请输入详细地址',
  保存: '保存',
  今天: '今天',
  本月: '本月',
  本季: '本季',
  本年: '本年',
  自定义时间: '自定义时间',
  至: '至',
  取消: '取消',
  确认: '确认',
  总库存小于起订量: '总库存小于起订量',
  选规格: '选规格',
  自提: '自提',
  不能输入小数: '不能输入小数',
  '最多可填{{qualityPrecision}}位小数': '最多可填{{qualityPrecision}}位小数',
  批量加购: '批量加购',
  填写数量: '填写数量',
  确定: '确定',
  以下规格库存不足: '以下规格库存不足',
  已自动修改数量: '已自动修改数量',
  '库存不足，已修改下单数量': '库存不足，已修改下单数量',
  '加载中…': '加载中…',
  删除成功: '删除成功',
  库存: '库存',
  购买数量: '购买数量',
  添加备注: '添加备注',
  最低起订量: '最低起订量',
  '，还差': '，还差',
  '总 数': '总 数',
  总金额: '总金额',
  移出购物车: '移出购物车',
  请输入内容: '请输入内容',
  输入内容: '输入内容',
  海外发货: '海外发货',
  国内发货: '国内发货',
  单: '单',
  个: '个',
  上次价: '上次价',
  暂无货品: '暂无货品',
  '--- 已经到底啦 ---': '--- 已经到底啦 ---',
  搜索: '搜索',
  综合: '综合',
  价格: '价格',
  销售单数: '销售单数',
  最新上架时间: '最新上架时间',
  货名: '货名',
  按: '按',
  排序: '排序',
  '按{{name}}排序': '按{{name}}排序',
  库存小于起订量: '库存小于起订量',
  '起订量为{{minNumStep}}{{unitName}}': '起订量为{{minNumStep}}{{unitName}}',
  当前数量加上起订量后大于库存: '当前数量加上起订量后大于库存',
  '最低起订量为{{minNumStep}}{{unitName}}':
    '最低起订量为{{minNumStep}}{{unitName}}',
  '最大库存为{{stock}}{{unitName}}': '最大库存为{{stock}}{{unitName}}',
  首页: '首页',
  全部货品: '全部货品',
  购物车: '购物车',
  我的: '我的',
  已下架: '已下架',
  库存不足: '库存不足',
  已删除: '已删除',
  全部: '全部',
  买过: '买过',
  推荐: '推荐',
  新品: '新品',
  爆品: '爆品',
  促销: '促销',
  销量: '销量',
  请求已过期: '请求已过期',
  进入店铺: '进入店铺',
  企业图片: '企业图片',
  企业介绍: '企业介绍',
  请求数据: '请求数据',
  加载下一页: '加载下一页',
  '请求中loading...': '请求中loading...',
  '请求出错了, {{msg}}': '请求出错了, {{msg}}',
  列表数据为空: '列表数据为空',
  注册: '注册',
  登录: '登录',
  重置密码: '重置密码',
  获取验证码: '获取验证码',
  重新发送: '重新发送',
  '请输入新密码（4-16位）': '请输入新密码（4-16位）',
  '请输入密码（4-16位）': '请输入密码（4-16位）',
  请输入密码: '请输入密码',
  请输入手机: '请输入手机',
  请输入手机或邮箱: '请输入手机或邮箱',
  请再次输入密码: '请再次输入密码',
  中文: '中文',
  越南语: '越南语',
  英文: '英文',
  手机号为18位以内的数字: '手机号为18位以内的数字',
  请输入正确的手机号: '请输入正确的手机号',
  请输入正确的邮箱号: '请输入正确的邮箱号',
  请输入密码和确认密码: '请输入密码和确认密码',
  '密码为4~16位字符': '密码为4~16位字符',
  两次输入的密码不一致: '两次输入的密码不一致',
  请输入邀请码: '请输入邀请码',
  '请先阅读并勾选《用户协议》和《隐私政策》':
    '请先阅读并勾选《用户协议》和《隐私政策》',
  请输入验证码: '请输入验证码',
  '密码修改成功 请用新密码登录': '密码修改成功 请用新密码登录',
  用已有账号登录: '用已有账号登录',
  新用户注册: '新用户注册',
  忘记密码: '忘记密码',
  请填写邀请码: '请填写邀请码',
  已阅读并同意: '已阅读并同意',
  用户协议: '用户协议',
  和: '和',
  隐私政策: '隐私政策',
  退出登录: '退出登录',
  获取用户信息失败: '获取用户信息失败',
  我的资料: '我的资料',
  点击登录: '点击登录',
  我的订单: '我的订单',
  待确认: '待确认',
  待发货: '待发货',
  '待收货/自提': '待收货/自提',
  已完成: '已完成',
  '退款/售后': '退款/售后',
  上传中: '上传中',
  上传头像失败: '上传头像失败',
  上传成功: '上传成功',
  更新用户信息失败: '更新用户信息失败',
  更换头像: '更换头像',
  头像: '头像',
  姓名: '姓名',
  公司: '公司',
  手机: '手机',
  邮箱: '邮箱',
  我的地址: '我的地址',
  待付款: '待付款',
  配送中: '配送中',
  已发货: '已发货',
  已取消: '已取消',
  '总额:': '总额:',
  '总量:': '总量:',
  已作废订单不汇总统计: '已作废订单不汇总统计',
  物流选项: '物流选项',
  '地址:': '地址:',
  运输费: '运输费',
  COD服务费: 'COD服务费',
  待自提: '待自提',
  待配送: '待配送',
  已作废: '已作废',
  头程已发货: '头程已发货',
  已到中转仓: '已到中转仓',
  跨境运输中: '跨境运输中',
  退货退款: '退货退款',
  下单成功: '下单成功',
  '订单总共(': '订单总共(',
  '项)': '项)',
  留言: '留言',
  '给订单留个言~': '给订单留个言~',
  提交订单: '提交订单',
  运费: '运费',
  '合计：': '合计：',
  合计: '合计',
  '点击“下单”即表示您同意': '点击“下单”即表示您同意',
  Epaifa的交易条款: 'Epaifa的交易条款',
  结账: '结账',
  下单: '下单',
  取消成功: '取消成功',
  货品已成功添加到购物车: '货品已成功添加到购物车',
  单据详情: '单据详情',
  'COD 服务费': 'COD 服务费',
  总计: '总计',
  实收: '实收',
  订单信息: '订单信息',
  店铺: '店铺',
  订单号: '订单号',
  交易时间: '交易时间',
  经手人: '经手人',
  备注: '备注',
  再次购买: '再次购买',
  单据列表: '单据列表',
  搜索订单: '搜索订单',
  日期: '日期',
  没有更多了: '没有更多了',
  '找不到订单哦~': '找不到订单哦~',
  联系我们: '联系我们',
  查看订单: '查看订单',
  '运输费 {{currencySymbol}} {{slot1}} + COD服务费 {{currencySymbol}} {{slot2}}':
    '运输费 {{currencySymbol}} {{slot1}} + COD服务费 {{currencySymbol}} {{slot2}}',
  价格不能小于0: '价格不能小于0',
  '最低价格需<=最高价格': '最低价格需<=最高价格',
  '最高价格需>=最低价格': '最高价格需>=最低价格',
  '整数位不能超过{{integerMaxLength}}位':
    '整数位不能超过{{integerMaxLength}}位',
  '小数位不能超过{{pricePrecision}}位': '小数位不能超过{{pricePrecision}}位',
  最低价格: '最低价格',
  最高价格: '最高价格',
  发货类型: '发货类型',
  重置: '重置',
  '商品找不到了…': '商品找不到了…',
  联系: '联系',
  库存不足无法下单: '库存不足无法下单',
  '添加成功，在购物车等你': '添加成功，在购物车等你',
  选购: '选购',
  筛选: '筛选',
  '支持货名/属性/条码': '支持货名/属性/条码',
  最近搜索: '最近搜索',
  删除: '删除',
  当前商品下架已删除: '当前商品下架已删除',
  '确认删除货品吗？': '确认删除货品吗？',
  全选: '全选',
  '已选：': '已选：',
  是否清空失效货品: '是否清空失效货品',
  清空成功: '清空成功',
  货品冲突: '货品冲突',
  '{{infoChangeCount}}件货品档案变更，': '{{infoChangeCount}}件货品档案变更，',
  '{{stockCount}}件货品库存不足，': '{{stockCount}}件货品库存不足，',
  '{{deleteCount}}件货品下架或删除，': '{{deleteCount}}件货品下架或删除，',
  '{{deleteCount}}个货品已下架或库存不足，是否删除？':
    '{{deleteCount}}个商品已下架或库存不足，是否删除？',
  是否删除: '是否删除',
  件失效货品: '件失效货品',
  清空: '清空',
  '购物车还是空的呐～': '购物车还是空的呐～',
  新: '新',
  爆: '爆',
  荐: '荐',
  促: '促',
  '登录已过期，请重新登录': '登录已过期，请重新登录',
  '出错了，请检查网络连接或重试': '出错了，请检查网络连接或重试',
  '{{err}}，请检查网络连接或重试': '{{err}}，请检查网络连接或重试',
  '{{msg}}，请检查网络连接或重试': '{{msg}}，请检查网络连接或重试',
  '出错了~': '出错了~',
  大额订单说明: '大额订单说明',
  '订单超过1亿，店长会主动联系您协助完成交易':
    '订单超过1亿，店长会主动联系您协助完成交易',
  '超低价格，品质保证': '超低价格，品质保证',
  海外: '海外',
  保税仓库: '保税仓库',
  胡志明市: '胡志明市',
  运费信息: '运费信息',
  邮寄方式: '邮寄方式',
  可用的: '可用的',
  成本: '成本',
  服务费: '服务费',
  任何数量: '任何数量',
  购买: '购买',
  货品属性: '货品属性',
  已指派专门的销售代表与您跟进: '已指派专门的销售代表与您跟进',
  货品总计: '货品总计',
  项: '项',
  货款: '货款',
  装箱规格: '装箱规格',
  补货中: '补货中',
  请选择下单货品: '请选择下单货品',
  请填写姓名: '请填写姓名',
  请填写联系电话: '请填写联系电话',
  请填写收货地址: '请填写收货地址',
  搜索货品: '搜索货品',
  请输入数字: '请输入数字',
  体验一下: '体验一下',
  请输入正确的手机号码: '请输入正确的手机号码',
  请输入正确的邮箱地址: '请输入正确的邮箱地址',
  多语言: '多语言',
  共: '共',
  种: '种',
  不含税: '不含税',
  订单金额不在COD范围内: '订单金额不在COD范围内',
  更多: '更多',
  获取: '获取',
  获取邀请码: '获取邀请码',
  申请邀请码: '申请邀请码',
  'Zalo扫一扫，加我为好友': 'Zalo扫一扫，加我为好友',
  预计送达: '预计送达',
  请选择物流: '请选择物流',
  首页模块为空: '首页模块为空',
  重量: '重量',
  体积: '体积',
  探索数以百万计的定制产品满足您的业务需求:
    '探索数以百万计的定制产品满足您的业务需求',
  推荐货品: '推荐货品',
  手机登录: '手机登录',
  邮箱登录: '邮箱登录',
  门店: '门店',
  仓库分拣中: '仓库分拣中',
  分拣中: '分拣中',
  退货中: '退货中',
  采购中: '采购中',
  分类: '分类',
  退换货: '退换货',
  退换单: '退换单',
  上传图片失败: '上传图片失败',
  批发价: '批发价',
  复购率: '复购率',
  月销量: '月销量',
  没有找到相关商品: '没有找到相关商品',
  商品总金额: '商品总金额',
  优惠: '优惠',
  '实付：': '实付：',
  退款成功: '退款成功',
  退货成功: '退货成功',
  退货关闭: '退货关闭',
  请选择站点: '请选择站点',
  分享: '分享',
  下载所有图片: '下载所有图片',
  相册: '相册',
  正在下载: '正在下载',
  '下载完成，在相册查看': '下载完成，在相册查看',
  新品2: '新品',
  商品分类: '商品分类',
  暂无商品2: '暂无商品',
  '生成图片中…': '生成图片中…',
  '新品相册！快来看看！': '新品相册！快来看看！',
  新品分享: '新品分享',
  扫码查看: '扫码查看',
  下载图片: '下载图片',
  分享链接: '分享链接',
  好物分享: '好物分享',
  下载: '下载',
  货品详情: '货品详情',
  货品已下架: '',
  查看新品: '查看新品',
  不含运费: '不含运费',
  '新品分享，点击查看': '新品分享，点击查看',
}
